import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
    prevCount?: number;
    newCount?: number;
};

const UpdateCount = ({ prevCount = 0, newCount = 0 }: Props) => {
    const { t } = useTranslation();
    const updateCount = Number(newCount) - Number(prevCount);

    if (updateCount) {
        return (
            <span data-testid='update-count'>
                {' '}
                {t('deploymentSummary.newUpdateCount', {
                    count: updateCount
                })}
            </span>
        );
    }

    return null;
};

export default React.memo(UpdateCount);
